import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from '~/state/authState';
import { ThemeManagerProvider } from '~/state/theme';

import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { HeadContextProvider } from './state/head';

const queryClient = new QueryClient();

function Providers({ children }) {
    return (
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <ThemeManagerProvider manager={{ lightOrDark: 'light', primary: '#1976D2' }}>
                    <HeadContextProvider>
                        <AuthProvider>{children}</AuthProvider>
                    </HeadContextProvider>
                </ThemeManagerProvider>
            </QueryClientProvider>
        </BrowserRouter>
    );
}
ReactDOM.render(
    // <React.StrictMode>
    <Providers>
        <App />
    </Providers>,
    // </React.StrictMode>,
    document.getElementById('character-tools-target'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
